import React, { useState, FC } from 'react'
import { css } from '@emotion/css'
import { JiraStatusField } from './jira-status-field'
import { JiraResolutionField } from './jira-resolution-field'
import { VulnerabilityStatusField } from './vulnerability-status-field'
import { VulnerabilitySubstatusField } from './vulnerability-substatus-field'
import {
  IconAdd,
  IconClose
} from '@contrast-security-inc/design-system-foundations'
import { Box, Row } from '../../../../../legacy-design-system/form'
import {
  IntegrationConfig,
  IssueStatus,
  ProjectStatus,
  Resolution
} from '../../api/shared'
import { useFormContext } from 'react-hook-form'
import { JiraIntegrationForm } from '../jira-form-schema'
import { JiraFormFieldTypes } from '../jira-form-field-types'
import { useDetermineJiraStatusesFromIssueType } from './use-determine-jira-statuses-from-issue-type'
import { useUpdateFormWithPopulatedIntegration } from './use-update-form-with-populated-integration'

export interface IntegrationRowProps {
  update: (value: IntegrationConfig) => void
  integrationValue: IntegrationConfig
  removeFieldRow?: () => void
  resolutions?: Resolution[]
  statuses?: ProjectStatus[]
}

export const IntegrationRow: FC<IntegrationRowProps> = (props) => {
  const { integrationValue, update, resolutions, statuses } = props
  const { watch } = useFormContext<JiraIntegrationForm>()

  const [issueTypeStatuses, setIssueTypeStatuses] = useState<IssueStatus[]>()

  const watchIssueType = watch(JiraFormFieldTypes.ISSUE_TYPE)

  useDetermineJiraStatusesFromIssueType({
    projectStatuses: statuses,
    issueType: watchIssueType,
    onUpdate: (matchingIssueTypesStatuses) => {
      setIssueTypeStatuses(matchingIssueTypesStatuses)
      // initialize to initial status
      if (!integrationValue.issue_status) {
        update({
          ...integrationValue,
          issue_status: matchingIssueTypesStatuses[0]
        })
      }
    }
  })

  useUpdateFormWithPopulatedIntegration({
    issueTypeStatuses,
    resolutions,
    integration: integrationValue,
    update
  })

  return (
    <Row>
      <Box
        basis={5}
        className={css`
          display: flex;
          flex-direction: row nowrap;
          padding-right: 10px;
        `}
      >
        <JiraStatusField {...props} statuses={issueTypeStatuses} />

        <div
          className={css`
            display: flex;
            align-items: center;
            padding: 5px;
          `}
        >
          <IconAdd
            size="sm"
            color="neutral60"
            testId={'integration-row-plus'}
          />
        </div>
        <JiraResolutionField {...props} />
      </Box>
      <Box
        basis={2}
        className={css`
          margin-left: 0px;
        `}
      >
        <VulnerabilityStatusField {...props} />
      </Box>
      <Box basis={5}>
        <VulnerabilitySubstatusField {...props} />
      </Box>
      {props.removeFieldRow && (
        <span
          className={css`
            display: flex;
            align-items: center;
            padding: 5px;
          `}
          onClick={props.removeFieldRow ?? undefined}
        >
          <IconClose
            size="sm"
            color="neutral60"
            testId={'integration-row-remove'}
          />
        </span>
      )}
    </Row>
  )
}
